
import type {OrderCreatedItem} from './order-created-item'

export type OrderCreated = {
  orderId: string,
  orderToken: string,
  items: { [string]: OrderCreatedItem }
}

const buildOrderCreated = function () : OrderCreated {
  return {
    orderId: '',
    orderToken: '',
    items: {}
  }
}

export {
  buildOrderCreated
}



// WEBPACK FOOTER //
// ./src/types/order-created.js